import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/credit-suisse-cop-hackathon-sept16/credit-suisse-cop-hackathon-sept16/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
Azure Passes will give you free credits to use the Azure cloud.
    </PageDescription>
    <p>{`Here’s what you need to do:`}</p>
    <ul>
      <li parentName="ul">{`Go to the event link to get your personal Azure Pass (you will need a GitHub user ID to login):`}
        <ul parentName="li">
          <li parentName="ul">{`(Link will be shared internally)`}</li>
        </ul>
      </li>
    </ul>
    <ul>
      <li parentName="ul">{`Copy the code to the clipboard, then follow the link to `}<a parentName="li" {...{
          "href": "https://www.microsoftazurepass.com/?ocid=AID3054457"
        }}>{`https://www.microsoftazurepass.com/`}</a>{` `}</li>
      <li parentName="ul">{`Login using your `}<strong parentName="li">{`private`}</strong>{` Microsoft / Azure account. Create a new one, if required.`}</li>
      <li parentName="ul"><strong parentName="li">{`NOTE`}</strong>{`: don’t use your company Azure account or ID. This won’t work.`}</li>
      <li parentName="ul">{`Follow the process`}</li>
      <li parentName="ul">{`You should find an `}<strong parentName="li">{`Azure Subscription`}</strong>{` in your account afterwards, called `}<span>{`Azure Pass - Sponsorship`}</span></li>
    </ul>
    <p>{`Problems? Contact your local tech team / Microsoft.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      